import { ErrorMessage } from '@hookform/error-message';
import React from 'react';
import FormError from './FormError';

interface Props {
  fieldName: string;
  errors: any;
}

const EnhancedErrorMessage: React.FC<Props> = ({ fieldName, errors }) => {
  return errors[fieldName] ? (
    <ErrorMessage
      errors={errors}
      name={fieldName}
      render={({ message }) => <FormError message={message as string} />}
    />
  ) : null;
};

export default EnhancedErrorMessage;
